import React from "react";
import styled from "@emotion/styled";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import {
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Grid,
  Link,
  Typography as MuiTypography,
  List,
  ListItem,
} from "@mui/material";
import { spacing } from "@mui/system";

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Typography = styled(MuiTypography)(spacing);

function PoliciesAndProcedures() {
  return (
    <React.Fragment>
      <Helmet title="Policies and Procedures" />

      <Grid container spacing={6} justifyContent="center">
        <Grid item xs={12} lg={9} xl={7}>
          <Typography variant="h2" gutterBottom display="inline">
            Breach Notification Policy
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} to="/">
              Dashboard
            </Link>
            <Typography>Breach Notification Policy</Typography>
          </Breadcrumbs>

          <Divider my={6} />

          <Typography variant="body1" paragraph>
            The Breach Notification Policy is an essential component of our compliance framework, designed to respond
            effectively to any unauthorized access, use, or disclosure of Protected Health Information (PHI) in
            accordance with the Health Insurance Portability and Accountability Act (HIPAA). This policy establishes
            procedures for identifying breaches, assessing the risk of harm, notifying affected individuals and relevant
            authorities, and mitigating the impact of the breach. Our commitment to transparency and swift action in the
            event of a breach is a cornerstone of our trustworthiness as a SaaS medical application provider.
          </Typography>

          <Typography variant="h5" gutterBottom>
            Breach Notification Overview
          </Typography>
          <List>
            <ListItem alignItems="flex-start">
              <Box display="flex" flexDirection="column">
                <Typography component="span">
                  <b>Identification and Assessment:</b> This section outlines the steps for identifying potential
                  breaches of PHI and the criteria for assessing whether an incident constitutes a breach under HIPAA.
                  It includes procedures for conducting a risk assessment to determine the probability that PHI has been
                  compromised.
                </Typography>
              </Box>
            </ListItem>
            <ListItem alignItems="flex-start">
              <Box display="flex" flexDirection="column">
                <Typography component="span">
                  <b>Notification Procedures:</b> Detailed procedures for notifying individuals affected by a breach, as
                  well as requirements for notifying the Secretary of Health and Human Services (HHS) and, in certain
                  circumstances, the media. This section also covers the content, timing, and methods of notification.
                </Typography>
              </Box>
            </ListItem>
            <ListItem alignItems="flex-start">
              <Box display="flex" flexDirection="column">
                <Typography component="span">
                  <b>Documentation and Reporting:</b> Guidelines for documenting breaches and the notification process,
                  including maintaining logs of identified breaches, assessments, and notifications. This part also
                  addresses the requirements for reporting breaches to HHS and other oversight bodies.
                </Typography>
              </Box>
            </ListItem>
            <ListItem alignItems="flex-start">
              <Box display="flex" flexDirection="column">
                <Typography component="span">
                  <b>Remediation and Mitigation:</b> Strategies for responding to breaches, including immediate
                  containment and longer-term measures to prevent future incidents. It outlines the process for
                  investigating the cause of the breach and implementing corrective actions to mitigate any harm to
                  affected individuals and reduce the risk of future breaches.
                </Typography>
              </Box>
            </ListItem>
            <ListItem alignItems="flex-start">
              <Box display="flex" flexDirection="column">
                <Typography component="span">
                  <b>Training and Awareness:</b> The importance of training staff on breach notification procedures and
                  raising awareness about the handling of incidents involving PHI. This ensures that all employees
                  understand their roles and responsibilities in preventing and responding to breaches.
                </Typography>
              </Box>
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default PoliciesAndProcedures;
